import Localization from 'lib/localization';

export default {
    signin: {
        lxTitle() {
            return Localization.get('badoo_homepage@page_signin.title');
        },

        lxSubtitle() {
            return Localization.get('badoo_homepage@page_signin.subtitle');
        },

        lxSignupLink() {
            return Localization.get('badoo_homepage@page_signin.signup_link');
        },

        lxLoginFieldLabel() {
            return Localization.get('badoo_homepage@page_signin.field_login.label');
        },

        lxPasswordFieldLabel() {
            return Localization.get('badoo_homepage@page_signin.field_password.label');
        },

        lxForgotPasswordLabel() {
            return Localization.get('badoo_homepage@page_signin.forgot_password.title');
        },
    },

    signup: {
        lxTitle() {
            return Localization.get('badoo_homepage@page_signup.title');
        },
    },
};
